export * as masthead from './modules/masthead.js';
export * as gtm from './modules/gtm.js';
export * as share from './modules/share.js';
export * as links from './modules/links.js';
export * as fitvid from './modules/fitvid.js';
export * as alerts from './modules/alert.js';
export * as favorites from './modules/MyFavorites.js';
export * as algolia from './modules/algolia/index.js';
export const blocks = {}; // this is necessary for webpack's export modules - see webpack.config.js

